(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 180;
  const PRODUCT_LIMIT = 6;
  const INTERNATIONAL_PRODUCT_IDS = new Set(["11284543111505","11284534624593","11161355845969","11161355649361","11161341559121","11161340707153","11161337037137","11161336480081","11161331073361","11157718729041","11117975077201","11117974946129","11117967409489","11117967311185","11117967016273","11117966786897","11116860309841","11116859687249","11116859392337","11116859195729","11116858900817","11116858769745","11116858605905","11116858278225","11116823347537","11116822692177","11116813320529","11116812501329","11116803719505","11116802965841","11116802441553","11116801786193","11116801524049","11116801294673","11116001755473","11116000739665","11116000346449","11100159344977","11043122872657","11043122020689","11043121103185","11043120775505","11043111502161","11014459785553","11005021684049","10995629490513","10992705274193","10992231940433","10966328115537","10949930910033","10949920457041","10949916787025","10949911314769","10949908889937","10949850857809","10944859570513","10944808911185","10944800620881","10929661968721","10926668808529","10920967176529","10920957542737","10920954495313","10920946893137","10920944730449","10920904098129","10920896463185","10914290729297"]);

  const money = (value) => {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      maximumFractionDigits: 0
    }).format(amount);
  };

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const imageUrl = (product) => {
    const image = product?.featured_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  };

  const productPrice = (product) => {
    if (Number.isFinite(Number(product?.price))) return money(product.price);
    if (Number.isFinite(Number(product?.price_min))) return money(product.price_min);
    const first = product?.variants?.[0]?.price;
    return first != null ? money(first) : '';
  };

  function render(form, payload, query) {
    const box = form.querySelector('[data-sb-predictive-results]');
    const input = form.querySelector('input[name="q"]');
    if (!box || !input) return;

    const results = payload?.resources?.results || {};
    const products = Array.isArray(results.products) ? results.products.filter(p => !INTERNATIONAL_PRODUCT_IDS.has(String(p.id).split('/').pop()) && !(Array.isArray(p.tags) && p.tags.includes('lager-internationellt'))).slice(0, PRODUCT_LIMIT) : [];
    const queries = Array.isArray(results.queries) ? results.queries.slice(0, 3) : [];

    if (!products.length && !queries.length) {
      box.innerHTML =
        '<div class="sb-predictive__empty">' +
          '<strong>Ingen direkt träff</strong>' +
          '<span>Tryck Enter för att söka efter “' + escapeHtml(query) + '”</span>' +
        '</div>';
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    let html = '';
    if (products.length) {
      html += '<div class="sb-predictive__label">Produkter</div><div class="sb-predictive__products">';
      for (const product of products) {
        const img = imageUrl(product);
        const price = productPrice(product);
        const url = product.url || ('/products/' + encodeURIComponent(product.handle || ''));
        html +=
          '<a class="sb-predictive__product" href="' + escapeHtml(url) + '" data-sb-predictive-item>' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="" width="68" height="68" loading="lazy">' : '<span class="sb-predictive__placeholder">✦</span>') +
            '<span class="sb-predictive__product-copy">' +
              '<strong>' + escapeHtml(product.title || '') + '</strong>' +
              (price ? '<small>' + escapeHtml(price) + '</small>' : '') +
            '</span>' +
          '</a>';
      }
      html += '</div>';
    }

    if (queries.length) {
      html += '<div class="sb-predictive__queries">';
      for (const suggestion of queries) {
        const text = suggestion?.text || suggestion?.styled_text || suggestion;
        if (!text) continue;
        const url = ROOT + 'search?q=' + encodeURIComponent(text) + '&type=product&options%5Bprefix%5D=last';
        html += '<a href="' + url + '" data-sb-predictive-item>🔎 ' + escapeHtml(text) + '</a>';
      }
      html += '</div>';
    }

    const allUrl = ROOT + 'search?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last';
    html += '<a class="sb-predictive__all" href="' + allUrl + '" data-sb-predictive-item>Visa alla resultat för “' + escapeHtml(query) + '” →</a>';

    box.innerHTML = html;
    box.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function init(form) {
    if (form.dataset.sbPredictiveReady === 'true') return;
    form.dataset.sbPredictiveReady = 'true';

    const input = form.querySelector('input[name="q"]');
    const box = form.querySelector('[data-sb-predictive-results]');
    if (!input || !box) return;

    let timer = 0;
    let controller = null;
    let activeIndex = -1;

    const close = () => {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    };

    const activeItems = () => Array.from(box.querySelectorAll('[data-sb-predictive-item]'));

    const setActive = (index) => {
      const items = activeItems();
      if (!items.length) return;
      items.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        if (i === index) el.scrollIntoView({ block: 'nearest' });
      });
      activeIndex = index;
    };

    const fetchResults = async () => {
      const query = input.value.trim();
      if (query.length < MIN_CHARS) {
        controller?.abort();
        close();
        return;
      }

      controller?.abort();
      controller = new AbortController();

      const url = new URL(ROOT + 'search/suggest.json', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product,query');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,tag');

      box.hidden = false;
      box.innerHTML = '<div class="sb-predictive__loading">Söker…</div>';
      input.setAttribute('aria-expanded', 'true');

      try {
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          signal: controller.signal,
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Predictive search failed');
        const payload = await response.json();
        if (input.value.trim() !== query) return;
        render(form, payload, query);
        activeIndex = -1;
      } catch (error) {
        if (error.name === 'AbortError') return;
        close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = window.setTimeout(fetchResults, DEBOUNCE_MS);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= MIN_CHARS && box.innerHTML.trim()) {
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    input.addEventListener('keydown', (event) => {
      if (box.hidden) return;
      const items = activeItems();
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (!items.length) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActive(activeIndex < items.length - 1 ? activeIndex + 1 : 0);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(activeIndex > 0 ? activeIndex - 1 : items.length - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        items[activeIndex].click();
      }
    });

    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-sb-predictive-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();